"use client";

import type { TourStepDefinition } from "./types";
import { useTargetRect } from "./use-target-rect";

export function TourOverlay({ step }: { step: TourStepDefinition }) {
  const rect = useTargetRect(step.target);

  if (!rect) {
    return null;
  }

  return (
    <div
      aria-hidden
      className="pointer-events-none fixed z-9999 rounded-2xl transition-all duration-300 ease-out"
      style={{
        top: rect.top - 10,
        left: rect.left - 18,
        width: rect.width + 36,
        height: rect.height + 20,
        boxShadow: "0 0 40px 8px hsl(var(--primary) / 0.16)",
      }}
    />
  );
}
